module.exports = __webpack_public_path__ + "img/Pic_SZPX.bb98549f.png";